<template>
  <b-modal
    id="modal-import-scheduler"
    ref="modal-import-scheduler"
    body-class="position-static"
    size="xl"
    title="Import thời khóa biểu"
    hide-footer
    no-close-on-backdrop
  >
    <b-row>
      <b-col
        cols="12"
        class="mb-2"
      >
        <b-row>
          <b-col cols="12">
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
              size="sm"
              class="mb-75 mr-75"
              @click="$refs.inputFileRef.$el.click()"
            >
              <feather-icon icon="UploadIcon" /> Tải lên file
            </b-button>
            <b-form-file
              ref="inputFileRef"
              accept=".xls, .xlsx"
              :hidden="true"
              plain
              @change="importExcel"
            />
            <!--/ upload button -->
            <b-card-text>Cho phép file XLS hoặc XLSX. Kích thước tối đa 800kB</b-card-text>
          </b-col>
          <b-col cols="12">
            <div class="mt-1">
              <p>
                <span style="font-weight: bold;color: red">MỘT SỐ LƯU Ý KHI THỰC HIỆN:</span> <br>
                <span>Format toàn bộ file excel về dạng text, đặc biệt là thông tin của ngày áp dụng(NGAY_AP_DUNG)</span> <br>
                <span>Các thông tin có ký hiệu <span style="color: red">(*)</span> là các thông tin bắt buộc</span> <br>
                <span><b>MA_LOP_HOC_PHAN</b>: Là trường thông tin bắt buộc, mã {{ classLabel }}</span><br>
                <span><b>TAI_KHOAN_GIANG_VIEN</b>: Là trường thông tin không bắt buộc, tài khoản giảng viên dạy {{ classLabel }}</span><br>
                <span><b>MA_PHONG_HOC</b>: Là trường thông tin bắt buộc, mã phòng học dành cho {{ classLabel }}</span><br>
                <span><b>TUAN</b>: Là trường thông tin bắt buộc, danh sách tuần học. Ví dụ tuần thứ 35, 36, 37 của năm 2024 thì ghi là "2024_2025_w35, 2024_2025_w36, 2024_2025_w37" </span><br>
                <span><b>THU</b>: Là trường thông tin bắt buộc, lịch học của {{ classLabel }}. Ví dụ lớp có lịch học vào Thứ 2 (Tiết 1,2,3) và Thứ 3 (Tiết 1, 2) thì điền vào cột THU tương ứng 1,2,3; 1,2</span><br>
              </p>
            </div>
          </b-col>
          <b-col cols="12">
            <div style="margin-top: 15px;">
              <b-button
                variant="success"
                @click="importSchedule()"
              >
                <span class="text-nowrap text-right">
                  <feather-icon icon="CheckSquareIcon" /> Nhập
                </span>
              </b-button>
              <b-button
                variant="secondary"
                style="margin-left: 10px"
                @click="downloadFile"
              >
                <span class="text-nowrap text-right">
                  <feather-icon icon="DownloadIcon" /> Tải file mẫu
                </span>
              </b-button>
            </div>
          </b-col>
        </b-row>
      </b-col>
      <!-- Per Page -->
      <b-col cols="12">
        <vue-good-table
          line-numbers
          :columns="columns"
          :rows="dataSources"
          :total-rows="totalRecords"
          :pagination-options="{
            enabled: true,
            perPage: serverParams.perPage
          }"
        >
          <div
            slot="emptystate"
            style="text-align: center; font-weight: bold"
          >
            Không có bản ghi nào !
          </div>
          <template
            slot="pagination-bottom"
            slot-scope="props"
          >
            <div class="d-flex justify-content-between flex-wrap">
              <div class="d-flex align-items-center mb-0 mt-1">
                <span class="text-nowrap"> Hiển thị 1 đến </span>
                <b-form-select
                  v-model="serverParams.perPage"
                  :options="['10', '20', '50']"
                  class="mx-1"
                  @input="(value) => props.perPageChanged({ currentPerPage: value })"
                />
                <span class="text-nowrap">của {{ totalRecords }} bản ghi</span>
              </div>
              <div>
                <b-pagination
                  v-model="serverParams.page"
                  :total-rows="totalRecords"
                  :per-page="serverParams.perPage"
                  class="mt-1 mb-0"
                  @input="(value) => props.pageChanged({ currentPage: value })"
                />
              </div>
            </div>
          </template>
        </vue-good-table>
      </b-col>
    </b-row>
    <b-overlay
      no-wrap
      variant="white"
      spinner-variant="primary"
      blur="0"
      opacity=".75"
      rounded="sm"
      :show="isLoading"
    />
  </b-modal>
</template>

<script>
import * as XLSX from 'xlsx'
import {
  BButton, BFormFile, BCol, BFormSelect, BOverlay, BPagination, BRow, BModal, BCardText,
} from 'bootstrap-vue'
import { VueGoodTable } from 'vue-good-table'
import '@core/scss/vue/libs/vue-good-table.scss'
import { Workbook } from '@syncfusion/ej2-excel-export'
import { OrganizationCode } from '@/const/code'
import { getUser } from '@/auth/utils'
import { showErrorToast, showSuccessToast, showWarningToast } from '@/utils/notification'
import { ApiCode } from '@/const/api'
import Ripple from 'vue-ripple-directive'
import api from './api'

export default {
  name: 'ProgrammeSubjectImport',
  directives: {
    Ripple,
  },
  components: {
    BCardText,
    BButton,
    BFormFile,
    BCol,
    BFormSelect,
    BOverlay,
    BPagination,
    BRow,
    VueGoodTable,
    BModal,
  },
  data() {
    return {
      columns: [
        {
          field: 'creditClassCode',
          label: 'Mã lớp học phần (*)',
          sortable: false,
          thClass: 'text-center',
        },
        {
          field: 'usernameTeacher',
          label: 'Tài khoản giảng viên (*)',
          sortable: false,
          thClass: 'text-center',
        },
        {
          field: 'roomCode',
          label: 'Mã phòng học (*)',
          sortable: false,
          thClass: 'text-center',
        },
        {
          field: 'yearWeek',
          label: 'Tuần áp dụng (*)',
          sortable: false,
          thClass: 'text-center',
        },
        {
          field: 'TH2',
          label: 'Thứ 2',
          sortable: false,
          thClass: 'text-center',
        },
        {
          field: 'TH3',
          label: 'Thứ 3',
          sortable: false,
          thClass: 'text-center',
        },
        {
          field: 'TH4',
          label: 'Thứ 4',
          sortable: false,
          thClass: 'text-center',
        },
        {
          field: 'TH5',
          label: 'Thứ 5',
          sortable: false,
          thClass: 'text-center',
        },
        {
          field: 'TH6',
          label: 'Thứ 6',
          sortable: false,
          thClass: 'text-center',
        },
        {
          field: 'TH7',
          label: 'Thứ 7',
          sortable: false,
          thClass: 'text-center',
        },
        {
          field: 'CN',
          label: 'Chủ nhật',
          sortable: false,
          thClass: 'text-center',
        },
      ],
      dataSources: [],
      dataExcel: [],
      dataExcelHandle: [],
      serverParams: {
        perPage: 10,
        page: 1,
      },
      totalRecords: 0,
      isLoading: false,
      classLabel: getUser().orgCode === OrganizationCode.HLUV ? 'lớp độc lập' : 'lớp học phần',
      daysCode: ['TH2', 'TH3', 'TH4', 'TH5', 'TH6', 'TH7', 'CN'],
    }
  },
  methods: {
    async importExcel(e) {
      const { files } = e.target
      if (files.length === 0) {
        showWarningToast(this, 'File dữ liệu đang bị trống')
        return
      }
      if (!/\.(xls|xlsx)$/.test(files[0].name.toLowerCase())) {
        showWarningToast(this, 'File đầu vào phải có kiểu định dạng xlsx hoặc xls')
        return
      }
      this.readFile(files)
    },

    readFile(files) {
      const fileReader = new FileReader()
      fileReader.onload = async ev => {
        const data = ev.target.result
        const workbook = XLSX.read(data, {
          type: 'binary',
        })
        const wsname = workbook.SheetNames[0]
        const ws = XLSX.utils.sheet_to_json(workbook.Sheets[wsname], {
          header: 0,
          defval: '',
        })
        const excelList = []
        if (ws.length === 0) {
          showWarningToast(this, 'File không có dữ liệu')
          return
        }
        for (let i = 0; i < ws.length; i++) {
          excelList.push(ws[i])
        }
        if (
          !excelList[0].hasOwnProperty('MA_LOP_HOC_PHAN')
          || !excelList[0].hasOwnProperty('TAI_KHOAN_GIANG_VIEN')
          || !excelList[0].hasOwnProperty('MA_PHONG_HOC')
          || !excelList[0].hasOwnProperty('TUAN')
          || !(excelList[0].hasOwnProperty('TH2') || excelList[0].hasOwnProperty('TH3')
            || excelList[0].hasOwnProperty('TH4') || excelList[0].hasOwnProperty('TH5')
            || excelList[0].hasOwnProperty('TH6') || excelList[0].hasOwnProperty('TH7')
            || excelList[0].hasOwnProperty('CN')
          )
        ) {
          showWarningToast(this, 'File chưa đúng định dạng')
          return
        }
        this.dataExcel = []
        for (let k = 0; k < excelList.length; k++) {
          const item = excelList[k]
          const obj = {
            creditClassCode: item.MA_LOP_HOC_PHAN,
            usernameTeacher: item.TAI_KHOAN_GIANG_VIEN,
            roomCode: item.MA_PHONG_HOC,
            yearWeek: item.TUAN,
            TH2: item.TH2,
            TH3: item.TH3,
            TH4: item.TH4,
            TH5: item.TH5,
            TH6: item.TH6,
            TH7: item.TH7,
            CN: item.CN,
          }
          this.dataExcel.push(obj)
        }
        this.dataSources = this.dataExcel
        this.totalRecords = this.dataExcel.length
      }
      fileReader.readAsBinaryString(files[0])
    },

    resetInputFile() {
      this.$refs.inputFileRef.reset()
    },

    async importSchedule() {
      const data = []
      this.dataExcel.forEach(item => {
        const element = {
          creditClassCode: item.creditClassCode,
          usernameTeacher: item.usernameTeacher,
          roomCode: item.roomCode,
          yearWeek: item.yearWeek,
          dayTurns: [],
        }
        this.daysCode.forEach(day => {
          if (item[day]) {
            element.dayTurns.push({ day, turns: item[day].toString().split(',') })
          }
        })
        data.push(element)
      })
      this.isLoading = true
      try {
        const res = await api.importScheduler(data)
        if (res.code === ApiCode.SUCCESS) {
          showSuccessToast(this, res.message)
        } else {
          showErrorToast(this, res.message)
        }
      } catch (e) {
        showErrorToast(this, e)
      } finally {
        this.resetInputFile()
        this.isLoading = false
      }
    },
    downloadFile() {
      const columns = [
        { index: 1, width: 130 },
        { index: 2, width: 170 },
        { index: 3, width: 130 },
        { index: 4, width: 130 },
        { index: 5, width: 170 },
        { index: 6, width: 170 },
        { index: 7, width: 170 },
        { index: 8, width: 170 },
        { index: 9, width: 170 },
        { index: 10, width: 170 },
        { index: 11, width: 170 },
      ]
      const rows = []
      const headerRow = {
        index: 1,
        cells: [
          {
            index: 1,
            value: 'MA_LOP_HOC_PHAN',
            colSpan: 1,
            style: {
              borders: {
                color: '#00000000',
                lineStyle: 'thin',
              },
            },
          },
          {
            index: 2,
            value: 'TAI_KHOAN_GIANG_VIEN',
            colSpan: 1,
            style: {
              borders: {
                color: '#00000000',
                lineStyle: 'thin',
              },
            },
          },
          {
            index: 3,
            value: 'MA_PHONG_HOC',
            colSpan: 1,
            style: {
              borders: {
                color: '#00000000',
                lineStyle: 'thin',
              },
            },
          },
          {
            index: 4,
            value: 'TUAN',
            colSpan: 1,
            style: {
              borders: {
                color: '#00000000',
                lineStyle: 'thin',
              },
            },
          },
          {
            index: 5,
            value: 'TH2',
            colSpan: 1,
            style: {
              borders: {
                color: '#00000000',
                lineStyle: 'thin',
              },
            },
          },
          {
            index: 6,
            value: 'TH3',
            colSpan: 1,
            style: {
              borders: {
                color: '#00000000',
                lineStyle: 'thin',
              },
            },
          },
          {
            index: 7,
            value: 'TH4',
            colSpan: 1,
            style: {
              borders: {
                color: '#00000000',
                lineStyle: 'thin',
              },
            },
          },
          {
            index: 8,
            value: 'TH5',
            colSpan: 1,
            style: {
              borders: {
                color: '#00000000',
                lineStyle: 'thin',
              },
            },
          },
          {
            index: 9,
            value: 'TH6',
            colSpan: 1,
            style: {
              borders: {
                color: '#00000000',
                lineStyle: 'thin',
              },
            },
          },
          {
            index: 10,
            value: 'TH7',
            colSpan: 1,
            style: {
              borders: {
                color: '#00000000',
                lineStyle: 'thin',
              },
            },
          },
          {
            index: 11,
            value: 'CN',
            colSpan: 1,
            style: {
              borders: {
                color: '#00000000',
                lineStyle: 'thin',
              },
            },
          },
        ],
      }

      rows.push(headerRow)
      const worksheets = [{ columns, rows }]
      const workbook = new Workbook({ worksheets }, 'xlsx')

      workbook.save('template_import_tkb.xlsx')
    },
  },
}
</script>
